import React from 'react';
import './less/index.less';
import Main from '../PaymentsPage'
import Payment from './views/payments.c'


export default function template() {
  let Component;
  const isMobile = this.isViewportMobile();
  const { match = {} } = this.props,
    type = match.params && match.params.secondType;
    if (type === 'payment' && !isMobile) {
      Component = Payment;
    } else {
      Component = Main;
    }

  return (
    <Component {...this.props} />
  )
}
